import React from 'react';
import Pricing from './Pricing';

const InternachiPricing: React.FC = () => (
  <Pricing
    discountFactor={0.9}
    discountMessage="InterNACHI® members save 10% — enter code INTERNACHI10 at checkout."
  />
);

export default InternachiPricing;
